import React, { useState } from "react";
import AppBar from "./AppBar";
import { useMandate } from "./MandateContext";
import customFetch from "../apicall/api";
import {
  resolvePaymentVendorDetails,
  findRegisteredVpaMandate,
  findInitiatedVpaMandate,
  contextFromRegisteredVpaMandate,
  providerFieldsFromVpaDetail,
} from "./mandateValidity";

function getInitials(name) {
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

// ─── local colour tokens ───────────────────────────────────────────────────
const BLUE = "#0178B7";

function statusColor(desc) {
  if (!desc) return "#9ca3af";
  const d = desc.toLowerCase();
  if (d.includes("active") || d.includes("register")) return "#166534";
  if (d.includes("initiat") || d.includes("pending") || d.includes("wait")) return "#d97706";
  if (d.includes("fail")    || d.includes("reject"))  return "#dc2626";
  if (d.includes("deactiv") || d.includes("cancel") || d.includes("expir"))  return "#6b7280";
  return "#5f259f";
}

export default function HouseholdSearch({ onNext, onBack, api_token }) {
  const { update } = useMandate();
  api_token = api_token || localStorage.getItem("api_token");

  const [input, setInput]                   = useState("");
  const [searchState, setSearchState]       = useState("idle"); // idle | searching | found | not_found
  const [members, setMembers]               = useState([]);
  const [searchedHH, setSearchedHH]         = useState("");
  const [householdId, setHouseholdId]       = useState(null);
  const [householdName, setHouseholdName]   = useState("");
  const [branchName, setBranchName]         = useState("");
  const [selected, setSelected]             = useState(null);
  const [inputError, setInputError]         = useState("");
  const [householdVendorDetails, setHouseholdVendorDetails] = useState([]);

  function handleSearch() {
    const val = input.trim();
    if (!val || val.length < 8) {
      setInputError("Please enter a valid household number");
      return;
    }
    setInputError("");
    setSearchState("searching");
    setSearchedHH(val);

    const queryParams = new URLSearchParams({ household_number: val }).toString();

    customFetch(
      process.env.REACT_APP_URL + "/upi/get/autopay/household/details?" + queryParams,
      { method: "GET", headers: { "api-token": api_token } }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.api_code === 4) {
          localStorage.clear();
          window.location.href = "/";
          return;
        }
        const hh = data && data[0];
        if (!hh || !hh.household_id) {
          setSearchState("not_found");
          return;
        }
        const mapped = (hh.family_deatils || []).map((fm) => ({
          memberId:         fm.family_member_number,
          memberName:       fm.family_member_name,
          mobileNo:         fm.mobile_no,
          family_member_id: fm.family_member_id,
          householdId:      hh.household_id,
          relationName:     fm.family_relation_name || "",
          vpaDetails:       fm.vpa_details || [],
        }));
        if (!mapped.length) {
          setSearchState("not_found");
          return;
        }
        setHouseholdId(hh.household_id);
        setHouseholdName(hh.household_name || "");
        setBranchName(hh.branch_name || "");
        setHouseholdVendorDetails(
          Array.isArray(hh.payment_vendor_details) ? hh.payment_vendor_details : []
        );
        setMembers(mapped);
        setSelected(null);
        setSearchState("found");
      })
      .catch(() => setSearchState("not_found"));
  }

  function handleTryAgain() {
    setInput("");
    setSearchState("idle");
    setInputError("");
    setSelected(null);
  }

  function handleProceed() {
    if (!selected) return;

    const vpaDetails = selected.vpaDetails || [];
    const registeredMandate = findRegisteredVpaMandate(vpaDetails);
    const initiatedMandate = findInitiatedVpaMandate(vpaDetails);
    const resolvedVendors = resolvePaymentVendorDetails(householdVendorDetails, members);
    const providerPrefill = initiatedMandate
      ? providerFieldsFromVpaDetail(initiatedMandate)
      : {
          provider: null,
          payment_vendor_code: "",
          mapId: null,
          paymentVendorName: "",
          partnerName: "",
        };

    const basePatch = {
      householdNumber: searchedHH,
      householdId: selected.householdId || householdId,
      householdName,
      branchName,
      searchedMembers: members,
      selectedMember: selected,
      paymentVendorDetails: resolvedVendors,
      skippedProviderSelection: false,
      ...providerPrefill,
      mandateStatus: "",
      validFrom: "",
      validTo: "",
      status: "idle",
      redirectUrl: "",
      redirectType: "",
      merchantUserId: "",
      authRequestId: "",
      mandateRef: "",
    };

    if (registeredMandate) {
      update({
        ...basePatch,
        skippedProviderSelection: true,
        ...contextFromRegisteredVpaMandate(registeredMandate),
      });
      onNext(2);
      return;
    }

    update(basePatch);
    onNext(0);
  }

  return (
    <section className="main-sec" style={{ minHeight: "100vh" }}>
      <div className="container fix-width">
      <AppBar title="Setup Autopay" onBack={searchState === "found" ? handleTryAgain : onBack} />

      <div style={{ padding: "0 0 20px" }}>

        {/* ── Brand header ── */}
        {/* <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{
            width: 64, height: 64, borderRadius: "50%", background: BLUE,
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            marginBottom: 6,
          }}>
            <span style={{ color: "#fff", fontWeight: 900, fontSize: 28 }}>N</span>
          </div>
          <div style={{ fontWeight: 700, fontSize: 20, color: BLUE }}>Navadhan</div>
          <div style={{ fontSize: 13, color: "#6b7280" }}>
            Search your household to begin autopay setup
          </div>
        </div> */}

        {/* ── Search card (visible when not yet found) ── */}
        {searchState !== "found" && (
          <div style={{ borderRadius: 16, marginBottom: 16, background: "#fff", boxShadow: "0 1px 6px rgba(0,0,0,0.08)", border: "1px solid #f0f0f0" }}>
            <div style={{ padding: "16px" }}>
              <label style={{ fontSize: 11, fontWeight: 700, textTransform: "uppercase", color: "#6b7280", letterSpacing: "0.05em" }}>
                Enter Household Number
              </label>
              <input
                type="text"
                placeholder="e.g. MP002LE003457"
                value={input}
                onChange={(e) => { setInput(e.target.value); setInputError(""); }}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                disabled={searchState === "searching"}
                style={{ borderRadius: 8, marginTop: 4, display: "block", width: "100%", padding: "8px 12px", fontSize: 15, border: inputError ? "1px solid #ef4444" : "1px solid #ced4da", background: "#fff", outline: "none", boxSizing: "border-box" }}
              />
              {inputError && <div style={{ fontSize: 12, color: "#ef4444", marginTop: 4 }}>{inputError}</div>}
              <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>
                Format: MP002LE003457
              </div>
              <button
                style={{ background: BLUE, color: "#fff", borderRadius: 8, border: "none", width: "100%", marginTop: 12, fontWeight: 700, padding: "10px 0", fontSize: 15, cursor: searchState === "searching" ? "not-allowed" : "pointer" }}
                onClick={handleSearch}
                disabled={searchState === "searching"}
              >
                {searchState === "searching"
                  ? <><span style={{ display: "inline-block", width: 14, height: 14, border: "2px solid #fff", borderRightColor: "transparent", borderRadius: "50%", animation: "upi-spin 0.75s linear infinite", marginRight: 8, verticalAlign: "middle" }} />Searching...</>
                  : "Search"}
              </button>
            </div>
          </div>
        )}

        {/* ── Skeleton rows while searching ── */}
        {searchState === "searching" && (
          <div style={{ borderRadius: 16, marginBottom: 16, background: "#fff", boxShadow: "0 1px 6px rgba(0,0,0,0.08)", border: "1px solid #f0f0f0" }}>
            <div style={{ padding: "16px" }}>
              {[1, 2, 3].map((i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
                  <div style={{ width: 44, height: 44, borderRadius: "50%", background: "#e5e7eb", animation: "upi-pulse 1.5s ease-in-out infinite" }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ height: 12, background: "#e5e7eb", borderRadius: 6, width: "60%", marginBottom: 6, animation: "upi-pulse 1.5s ease-in-out infinite" }} />
                    <div style={{ height: 10, background: "#e5e7eb", borderRadius: 6, width: "40%", animation: "upi-pulse 1.5s ease-in-out infinite" }} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ── Not found alert ── */}
        {searchState === "not_found" && (
          <div style={{ border: "2px solid #ef4444", background: "#fef2f2", borderRadius: 16, padding: 16, marginBottom: 16 }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
              <span style={{ fontSize: 22, marginRight: 8 }}>⚠️</span>
              <strong style={{ color: "#991b1b" }}>Household Not Found</strong>
            </div>
            <p style={{ fontSize: 13, color: "#7f1d1d", margin: 0 }}>
              No records found for household <strong>{searchedHH}</strong>. Please check and try a different number.
            </p>
            <button
              style={{ borderRadius: 20, background: "transparent", color: "#4b5563", border: "1px solid #9ca3af", fontSize: 12, padding: "4px 12px", marginTop: 8, cursor: "pointer" }}
              onClick={handleTryAgain}
            >
              Try a Different Number
            </button>
            <div style={{ fontSize: 12, marginTop: 8 }}>
              <span style={{ color: BLUE, cursor: "pointer", fontWeight: 600 }}>
                Need help? Contact Navadhan Support →
              </span>
            </div>
          </div>
        )}

        {/* ── Member list ── */}
        {searchState === "found" && (
          <div style={{ animation: "upi-fadeIn 0.35s ease" }}>
            {/* ── Household info card ── */}
            <div style={{ borderRadius: 12, background: "#f0fdf4", border: "1px solid #bbf7d0", padding: "10px 14px", marginBottom: 10 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: BLUE }}>{householdName || searchedHH}</div>
              <div style={{ display: "flex", gap: 8, marginTop: 2, flexWrap: "wrap" }}>
                <span style={{ fontSize: 11, color: "#6b7280" }}>{searchedHH}</span>
                {branchName && <span style={{ fontSize: 11, color: "#6b7280" }}>· {branchName}</span>}
                <span style={{ fontSize: 11, color: "#6b7280" }}>· {members.length} member(s)</span>
              </div>
            </div>

            {members.map((m) => {
              const isSel = selected && selected.memberId === m.memberId;
              return (
                <div
                  key={m.memberId}
                  onClick={() => setSelected(m)}
                  style={{
                    background: "#fff",
                    border: isSel ? `2px solid ${BLUE}` : "1px solid #e5e7eb",
                    borderRadius: 16,
                    padding: "10px 12px",
                    marginBottom: 10,
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    cursor: "pointer",
                    position: "relative",
                  }}
                >
                  <div style={{
                    width: 44, height: 44, borderRadius: "50%", background: BLUE,
                    color: "#fff", display: "flex", alignItems: "center",
                    justifyContent: "center", fontWeight: 700, fontSize: 15, flexShrink: 0,
                  }}>
                    {getInitials(m.memberName)}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: 15 }}>{m.memberName}</div>
                    <div style={{ fontSize: 11, color: "#9ca3af" }}>
                      {m.memberId}{m.relationName ? ` · ${m.relationName}` : ""}
                    </div>
                    {m.vpaDetails && m.vpaDetails.length > 0 && m.vpaDetails.map((v, i) => (
                      <div key={i} style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4, flexWrap: "wrap" }}>
                        <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 12, background: statusColor(v.mandate_status || v.status_type_description), color: "#fff" }}>
                          {v.mandate_status || v.status_type_description || v.autopay_status_type_flag}
                        </span>
                        {v.partner_name && (
                          <span style={{ fontSize: 11, color: "#374151", fontWeight: 600 }}>
                            {v.partner_name}
                          </span>
                        )}
                        {v.masked_bank_account
                          ? <span style={{ fontSize: 11, color: "#6b7280" }}>Acc: {v.masked_bank_account}</span>
                          : v.upi_id && v.upi_id.includes('@')
                            ? <span style={{ fontSize: 11, color: "#6b7280" }}>{v.upi_id}</span>
                            : null}
                        {v.max_billing_amount != null && (
                          <span style={{ fontSize: 11, color: "#6b7280" }}>₹{Number(v.max_billing_amount).toLocaleString("en-IN")}</span>
                        )}
                      </div>
                    ))}
                  </div>
                  <button
                    onClick={(e) => { e.stopPropagation(); setSelected(m); }}
                    style={{
                      borderRadius: 20,
                      fontSize: 12,
                      border: `1.5px solid ${BLUE}`,
                      background: isSel ? BLUE : "transparent",
                      color: isSel ? "#fff" : BLUE,
                      whiteSpace: "nowrap",
                      padding: "4px 12px",
                      cursor: "pointer",
                    }}
                  >
                    {isSel ? "Selected ✓" : "Select"}
                  </button>
                </div>
              );
            })}

            <button
              style={{
                background: selected ? BLUE : "#d1d5db",
                color: "#fff",
                borderRadius: 8,
                border: "none",
                cursor: selected ? "pointer" : "not-allowed",
                width: "100%",
                fontWeight: 700,
                marginTop: 8,
                padding: "12px 0",
                fontSize: 15,
              }}
              disabled={!selected}
              onClick={handleProceed}
            >
              {selected ? `Proceed with ${selected.memberName}` : "Select a member to proceed"}
            </button>
          </div>
        )}
      </div>

      <style>{`
        @keyframes upi-pulse {
          0%,100% { opacity:1; } 50% { opacity:0.35; }
        }
        @keyframes upi-fadeIn {
          from { opacity:0; transform:translateY(8px); }
          to   { opacity:1; transform:translateY(0); }
        }
        @keyframes upi-spin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
      `}</style>
      </div>
    </section>
  );
}
